export default __webpack_public_path__ + "static/media/fontMulish900_cyrillic.6893fb76.woff2";